import { useState } from "react";
import { PlayerCard } from "../../../services/bedrock";
import { cloneDeep } from "lodash";

export interface PreviewContextData {
  playerCard?: PlayerCard;
  setPlayerCard: (playerCard?: PlayerCard) => void;
  updatePlayerCard: (playerCard: Partial<PlayerCard>) => void;
  focusedWidgetId: number | undefined;
  setFocusedWidgetId: (_: number | undefined) => void;
  selectedWidgetId: number | undefined;
  setSelectedWidgetId: (_: number | undefined) => void;
}

export const InitialPreviewContextData: PreviewContextData = {
  playerCard: undefined,
  setPlayerCard: (_?: PlayerCard) => {},
  updatePlayerCard: (_: Partial<PlayerCard>) => {},
  focusedWidgetId: undefined,
  setFocusedWidgetId: (_: number | undefined) => {},
  selectedWidgetId: undefined,
  setSelectedWidgetId: (_: number | undefined) => {},
};

export const PreviewContext = (): PreviewContextData => {
  const [playerCard, _setPlayerCard] = useState<PlayerCard>();
  const setPlayerCard = (playerCard?: PlayerCard) => {
    if (!playerCard) {
      _setPlayerCard(undefined);
    } else {
      _setPlayerCard({ ...cloneDeep(playerCard) });
    }
  };
  const updatePlayerCard = (playerCard: Partial<PlayerCard>) => {
    _setPlayerCard(prev => {
      if (prev) {
        return { ...cloneDeep(prev), ...playerCard };
      } else {
        return prev;
      }
    });
  };
  const [focusedWidgetId, setFocusedWidgetId] = useState<number>();
  const [selectedWidgetId, setSelectedWidgetId] = useState<number>();

  return {
    playerCard,
    setPlayerCard,
    updatePlayerCard,
    focusedWidgetId,
    setFocusedWidgetId,
    selectedWidgetId,
    setSelectedWidgetId,
  };
};
